import React from "react";

export default function About() {
  return (
    <div className="p-10 text-toast-blue font-toast flex flex-col min-h-screen">
      <h2 className="text-3xl font-bold mb-4">About Us</h2>
      <p className="mb-4 text-gray-700">
        PDF CropEase is crafted by Drenx Technologies to help ecommerce sellers crop, organize, and manage shipping labels faster.
      </p>

      <h3 className="text-xl font-semibold mt-6 mb-2">Privacy Policy</h3>
      <p className="text-gray-700">
        We respect your privacy. None of your uploaded PDFs are stored. All processing happens securely and temporarily.
      </p>

      <h3 className="text-xl font-semibold mt-6 mb-2">Terms & Conditions</h3>
      <p className="text-gray-700">
        PDF CropEase is a free tool provided as-is. We are not liable for any issues caused by incorrect usage or label modifications.
      </p>

      <h3 className="text-xl font-semibold mt-6 mb-2">Contact & Address</h3>
      <p className="text-gray-700">
        📍 Drenx Technologies, No. 27/9,Kannagi Nagar, 2nd Street, P.N Road,Near Busstand, Tiruppur 641602<br/>
        📧 drenxtechnologies@gmail.com <br/>
        Customer support & Feedback:8015867496
      </p>

      <footer className="text-sm text-gray-500 mt-auto pt-4 border-t text-center">
      © 2025 by Drenx Technologies. All rights reserved. <br />
        📘 <a href="#" className="hover:underline">Facebook</a> &nbsp;
        📸 <a href="#" className="hover:underline">Instagram</a> &nbsp;
        ▶️ <a href="#" className="hover:underline">YouTube</a>
      </footer>
    </div>
  );
}
